(function () {
  document.querySelectorAll('[data-aceites-categories]').forEach(function (root) {
    var track = root.querySelector('[data-aceites-categories-track]');
    var nextBtn = root.querySelector('[data-aceites-categories-next]');
    var prevBtn = root.querySelector('[data-aceites-categories-prev]');
    if (!track) return;

    function scrollAmount() {
      var first = track.querySelector('.aceites-categories__item');
      if (!first) return 320;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '12') || 12;
      return first.getBoundingClientRect().width + gap;
    }

    function updateNav() {
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      if (prevBtn) prevBtn.hidden = atStart;
      if (nextBtn) nextBtn.hidden = atEnd;
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
  });
})();
